// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Base ─────────────────────────────────────────────────────────────── */
*, *::before, *::after { box-sizing: border-box; }

/* ─── Password Gate ─────────────────────────────────────────────────────── */
.admin-gate {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f6f9;
}

.admin-gate__card {
  background: #fff;
  border-radius: 16px;
  padding: 48px 40px;
  width: 100%;
  max-width: 380px;
  text-align: center;
  box-shadow: 0 4px 32px rgba(0,0,0,.10);
}

.admin-gate__icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #f0f0ff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #4f46e5;
  margin: 0 auto 20px;
}

.admin-gate__title { font-size: 22px; font-weight: 700; margin: 0 0 6px; color: #111; }
.admin-gate__sub   { font-size: 14px; color: #777; margin: 0 0 24px; }

.admin-gate__input { width: 100%; text-align: center; margin-bottom: 8px; }
.admin-gate__input--error { border-color: #ef4444 !important; animation: shake .3s; }
@keyframes shake {
  0%,100% { transform: translateX(0); }
  25%      { transform: translateX(-6px); }
  75%      { transform: translateX(6px); }
}
.admin-gate__error { color: #ef4444; font-size: 13px; margin: 0 0 12px; }
.admin-gate__btn   { width: 100%; margin-top: 8px; }

/* ─── Layout ────────────────────────────────────────────────────────────── */
.admin-page {
  display: flex;
  min-height: 100vh;
  background: #f4f6f9;
  font-family: 'Inter', 'DM Sans', sans-serif;
}

.admin-page__sidebar {
  width: 220px;
  min-height: 100vh;
  background: #1a1a2e;
  padding: 32px 20px;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  align-self: flex-start;
  height: 100vh;
}

.admin-page__main {
  flex: 1 1;
  padding: 32px 28px;
  max-width: 960px;
}

/* ─── Sidebar ───────────────────────────────────────────────────────────── */
.admin-sidebar__header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}

.admin-sidebar__logo {
  width: 44px;
  height: 44px;
  background: #4f46e5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
  flex-shrink: 0;
}

.admin-sidebar__title { color: #fff; font-weight: 700; font-size: 15px; margin: 0; }
.admin-sidebar__sub   { color: #888; font-size: 12px; margin: 2px 0 0; }

.admin-sidebar__view-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #a0aec0;
  text-decoration: none;
  font-size: 13px;
  padding: 10px 12px;
  border-radius: 8px;
  transition: background .2s, color .2s;
}
.admin-sidebar__view-link:hover {
  background: rgba(255,255,255,.08);
  color: #fff;
}

/* ─── Toast ─────────────────────────────────────────────────────────────── */
.admin-toast {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  animation: slideIn .25s ease;
  box-shadow: 0 4px 16px rgba(0,0,0,.18);
}
.admin-toast--success { background: #22c55e; }
.admin-toast--danger  { background: #ef4444; }
@keyframes slideIn {
  from { opacity: 0; transform: translateX(40px); }
  to   { opacity: 1; transform: translateX(0); }
}

/* ─── Modal ─────────────────────────────────────────────────────────────── */
.admin-modal-backdrop {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.45);
  display: flex; align-items: center; justify-content: center;
  z-index: 9000;
}
.admin-modal {
  background: #fff;
  border-radius: 16px;
  padding: 36px 32px;
  max-width: 360px;
  width: 90%;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0,0,0,.2);
}
.admin-modal__icon { font-size: 36px; color: #f59e0b; margin-bottom: 12px; }
.admin-modal__text { font-size: 17px; font-weight: 700; margin: 0 0 6px; color: #111; }
.admin-modal__sub  { font-size: 13px; color: #777; margin: 0 0 24px; }
.admin-modal__actions { display: flex; gap: 10px; justify-content: center; }

/* ─── Cards ─────────────────────────────────────────────────────────────── */
.admin-form-card,
.admin-table-card {
  background: #fff;
  border-radius: 14px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,.06);
}

.admin-form-card__heading {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 24px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ─── Form grid ─────────────────────────────────────────────────────────── */
.admin-form__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.admin-field { display: flex; flex-direction: column; gap: 6px; }
.admin-field--full { grid-column: 1 / -1; }
.admin-field--error .admin-input { border-color: #ef4444; }

.admin-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.admin-label__opt { font-weight: 400; color: #9ca3af; }

.admin-input {
  padding: 10px 14px;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #111;
  outline: none;
  background: #fff;
  transition: border-color .2s;
  width: 100%;
}
.admin-input:focus { border-color: #4f46e5; }

.admin-textarea {
  resize: vertical;
  min-height: 160px;
  font-family: inherit;
  line-height: 1.6;
}

.admin-char-count {
  font-size: 12px;
  color: #9ca3af;
  text-align: right;
}

.admin-error { font-size: 12px; color: #ef4444; }

/* ─── Image upload row ──────────────────────────────────────────────────── */
.admin-img-row {
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.admin-upload-btn {
  white-space: nowrap;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.admin-img-preview-wrap {
  position: relative;
  display: inline-block;
  margin-top: 10px;
}

.admin-img-preview {
  width: 160px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1.5px solid #e5e7eb;
  display: block;
}

.admin-img-preview__remove {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ef4444;
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  line-height: 1;
}

/* ─── Form actions ──────────────────────────────────────────────────────── */
.admin-form__actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 24px;
}

/* ─── Buttons ───────────────────────────────────────────────────────────── */
.admin-btn {
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: opacity .2s, transform .1s;
}
.admin-btn:active { transform: scale(.97); }

.admin-btn--primary { background: #4f46e5; color: #fff; }
.admin-btn--primary:hover { opacity: .88; }
.admin-btn--ghost {
  background: transparent;
  border: 1.5px solid #e5e7eb;
  color: #374151;
}
.admin-btn--ghost:hover { background: #f9fafb; }
.admin-btn--danger { background: #ef4444; color: #fff; }
.admin-btn--danger:hover { opacity: .88; }

/* ─── Table card header ─────────────────────────────────────────────────── */
.admin-table-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.admin-search-wrap {
  position: relative;
}
.admin-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 15px;
}
.admin-search-input { padding-left: 36px; width: 220px; }

/* ─── Table ─────────────────────────────────────────────────────────────── */
.admin-table-wrap { overflow-x: auto; }

.admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.admin-table th {
  text-align: left;
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: .04em;
  border-bottom: 1.5px solid #f0f0f0;
}

.admin-table td {
  padding: 12px 12px;
  border-bottom: 1px solid #f5f5f5;
  vertical-align: middle;
  color: #374151;
}

.admin-table tbody tr:last-child td { border-bottom: none; }
.admin-table tbody tr:hover { background: #fafafa; }
.admin-table__row--active { background: #f0effe !important; }

.admin-table__title-cell {
  font-weight: 600;
  max-width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-table__date { color: #6b7280; white-space: nowrap; font-size: 13px; }

.admin-table__tags { display: flex; flex-wrap: wrap; gap: 4px; }
.admin-table__tag {
  background: #ede9fe;
  color: #4f46e5;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
}

.admin-table__thumb {
  width: 52px;
  height: 36px;
  object-fit: cover;
  border-radius: 6px;
  display: block;
}
.admin-table__thumb--empty {
  width: 52px;
  height: 36px;
  border-radius: 6px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d1d5db;
  font-size: 16px;
}

.admin-table__actions { display: flex; gap: 6px; }

.admin-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 7px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  transition: background .15s;
}
.admin-icon-btn--edit   { background: #f0effe; color: #4f46e5; }
.admin-icon-btn--edit:hover   { background: #ddd6fe; }
.admin-icon-btn--delete { background: #fef2f2; color: #ef4444; }
.admin-icon-btn--delete:hover { background: #fecaca; }

/* ─── Empty state ───────────────────────────────────────────────────────── */
.admin-empty {
  text-align: center;
  padding: 48px 20px;
  color: #9ca3af;
}
.admin-empty p { margin: 8px 0 0; font-size: 14px; }

/* ─── Responsive ────────────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .admin-page { flex-direction: column; }
  .admin-page__sidebar {
    width: 100%;
    min-height: auto;
    height: auto;
    position: static;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px 20px;
    gap: 12px;
  }
  .admin-sidebar__header { margin-bottom: 0; }
  .admin-page__main { padding: 20px 16px; }
  .admin-form__grid { grid-template-columns: 1fr; }
  .admin-field--full { grid-column: 1; }
  .admin-search-input { width: 160px; }
}`, "",{"version":3,"sources":["webpack://./src/pages/AdminPanel.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E,yBAAyB,sBAAsB,EAAE;;AAEjD,8EAA8E;AAC9E;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,WAAW,EAAE;AACtF,qBAAqB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;;AAErE,qBAAqB,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC1E,4BAA4B,gCAAgC,EAAE,oBAAoB,EAAE;AACpF;EACE,UAAU,wBAAwB,EAAE;EACpC,WAAW,2BAA2B,EAAE;EACxC,WAAW,0BAA0B,EAAE;AACzC;AACA,qBAAqB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxE,qBAAqB,WAAW,EAAE,eAAe,EAAE;;AAEnD,8EAA8E;AAC9E;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,wBAAwB,WAAW,EAAE,gBAAgB,EAAE,eAAe,EAAE,SAAS,EAAE;AACnF,wBAAwB,WAAW,EAAE,eAAe,EAAE,eAAe,EAAE;;AAEvE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,sCAAsC;AACxC;AACA,wBAAwB,mBAAmB,EAAE;AAC7C,wBAAwB,mBAAmB,EAAE;AAC7C;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,8EAA8E;AAC9E;EACE,eAAe,EAAE,QAAQ;EACzB,2BAA2B;EAC3B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,qCAAqC;AACvC;AACA,qBAAqB,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC3E,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,WAAW,EAAE;AACtF,qBAAqB,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACrE,wBAAwB,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE;;AAE3E,8EAA8E;AAC9E;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE,qBAAqB,mBAAmB,EAAE;AAC1C,mCAAmC,qBAAqB,EAAE;;AAE1D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,oBAAoB,gBAAgB,EAAE,cAAc,EAAE;;AAEtD;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,WAAW;AACb;AACA,qBAAqB,qBAAqB,EAAE;;AAE5C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,eAAe,eAAe,EAAE,cAAc,EAAE;;AAEhD,8EAA8E;AAC9E;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;AACA,oBAAoB,qBAAqB,EAAE;;AAE3C,sBAAsB,mBAAmB,EAAE,WAAW,EAAE;AACxD,4BAA4B,YAAY,EAAE;AAC1C;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;AACA,0BAA0B,mBAAmB,EAAE;AAC/C,qBAAqB,mBAAmB,EAAE,WAAW,EAAE;AACvD,2BAA2B,YAAY,EAAE;;AAEzC,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;AACA,sBAAsB,kBAAkB,EAAE,YAAY,EAAE;;AAExD,8EAA8E;AAC9E,oBAAoB,gBAAgB,EAAE;;AAEtC;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA,sCAAsC,mBAAmB,EAAE;AAC3D,8BAA8B,mBAAmB,EAAE;AACnD,4BAA4B,8BAA8B,EAAE;;AAE5D;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB,cAAc,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AAE3E,qBAAqB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC/D;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB,aAAa,EAAE,QAAQ,EAAE;;AAEjD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;AACA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,gCAAgC,mBAAmB,EAAE;AACrD,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,gCAAgC,mBAAmB,EAAE;;AAErD,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA,iBAAiB,eAAe,EAAE,eAAe,EAAE;;AAEnD,8EAA8E;AAC9E;EACE,cAAc,sBAAsB,EAAE;EACtC;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,SAAS;EACX;EACA,yBAAyB,gBAAgB,EAAE;EAC3C,oBAAoB,kBAAkB,EAAE;EACxC,oBAAoB,0BAA0B,EAAE;EAChD,qBAAqB,cAAc,EAAE;EACrC,sBAAsB,YAAY,EAAE;AACtC","sourcesContent":["/* ─── Base ─────────────────────────────────────────────────────────────── */\n*, *::before, *::after { box-sizing: border-box; }\n\n/* ─── Password Gate ─────────────────────────────────────────────────────── */\n.admin-gate {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f4f6f9;\n}\n\n.admin-gate__card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 48px 40px;\n  width: 100%;\n  max-width: 380px;\n  text-align: center;\n  box-shadow: 0 4px 32px rgba(0,0,0,.10);\n}\n\n.admin-gate__icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 16px;\n  background: #f0f0ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  color: #4f46e5;\n  margin: 0 auto 20px;\n}\n\n.admin-gate__title { font-size: 22px; font-weight: 700; margin: 0 0 6px; color: #111; }\n.admin-gate__sub   { font-size: 14px; color: #777; margin: 0 0 24px; }\n\n.admin-gate__input { width: 100%; text-align: center; margin-bottom: 8px; }\n.admin-gate__input--error { border-color: #ef4444 !important; animation: shake .3s; }\n@keyframes shake {\n  0%,100% { transform: translateX(0); }\n  25%      { transform: translateX(-6px); }\n  75%      { transform: translateX(6px); }\n}\n.admin-gate__error { color: #ef4444; font-size: 13px; margin: 0 0 12px; }\n.admin-gate__btn   { width: 100%; margin-top: 8px; }\n\n/* ─── Layout ────────────────────────────────────────────────────────────── */\n.admin-page {\n  display: flex;\n  min-height: 100vh;\n  background: #f4f6f9;\n  font-family: 'Inter', 'DM Sans', sans-serif;\n}\n\n.admin-page__sidebar {\n  width: 220px;\n  min-height: 100vh;\n  background: #1a1a2e;\n  padding: 32px 20px;\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  top: 0;\n  align-self: flex-start;\n  height: 100vh;\n}\n\n.admin-page__main {\n  flex: 1;\n  padding: 32px 28px;\n  max-width: 960px;\n}\n\n/* ─── Sidebar ───────────────────────────────────────────────────────────── */\n.admin-sidebar__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.admin-sidebar__logo {\n  width: 44px;\n  height: 44px;\n  background: #4f46e5;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.admin-sidebar__title { color: #fff; font-weight: 700; font-size: 15px; margin: 0; }\n.admin-sidebar__sub   { color: #888; font-size: 12px; margin: 2px 0 0; }\n\n.admin-sidebar__view-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #a0aec0;\n  text-decoration: none;\n  font-size: 13px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  transition: background .2s, color .2s;\n}\n.admin-sidebar__view-link:hover {\n  background: rgba(255,255,255,.08);\n  color: #fff;\n}\n\n/* ─── Toast ─────────────────────────────────────────────────────────────── */\n.admin-toast {\n  position: fixed;\n  top: 24px;\n  right: 24px;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 20px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  animation: slideIn .25s ease;\n  box-shadow: 0 4px 16px rgba(0,0,0,.18);\n}\n.admin-toast--success { background: #22c55e; }\n.admin-toast--danger  { background: #ef4444; }\n@keyframes slideIn {\n  from { opacity: 0; transform: translateX(40px); }\n  to   { opacity: 1; transform: translateX(0); }\n}\n\n/* ─── Modal ─────────────────────────────────────────────────────────────── */\n.admin-modal-backdrop {\n  position: fixed; inset: 0;\n  background: rgba(0,0,0,.45);\n  display: flex; align-items: center; justify-content: center;\n  z-index: 9000;\n}\n.admin-modal {\n  background: #fff;\n  border-radius: 16px;\n  padding: 36px 32px;\n  max-width: 360px;\n  width: 90%;\n  text-align: center;\n  box-shadow: 0 8px 40px rgba(0,0,0,.2);\n}\n.admin-modal__icon { font-size: 36px; color: #f59e0b; margin-bottom: 12px; }\n.admin-modal__text { font-size: 17px; font-weight: 700; margin: 0 0 6px; color: #111; }\n.admin-modal__sub  { font-size: 13px; color: #777; margin: 0 0 24px; }\n.admin-modal__actions { display: flex; gap: 10px; justify-content: center; }\n\n/* ─── Cards ─────────────────────────────────────────────────────────────── */\n.admin-form-card,\n.admin-table-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 28px;\n  margin-bottom: 24px;\n  box-shadow: 0 2px 12px rgba(0,0,0,.06);\n}\n\n.admin-form-card__heading {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 24px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ─── Form grid ─────────────────────────────────────────────────────────── */\n.admin-form__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.admin-field { display: flex; flex-direction: column; gap: 6px; }\n.admin-field--full { grid-column: 1 / -1; }\n.admin-field--error .admin-input { border-color: #ef4444; }\n\n.admin-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n}\n.admin-label__opt { font-weight: 400; color: #9ca3af; }\n\n.admin-input {\n  padding: 10px 14px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #111;\n  outline: none;\n  background: #fff;\n  transition: border-color .2s;\n  width: 100%;\n}\n.admin-input:focus { border-color: #4f46e5; }\n\n.admin-textarea {\n  resize: vertical;\n  min-height: 160px;\n  font-family: inherit;\n  line-height: 1.6;\n}\n\n.admin-char-count {\n  font-size: 12px;\n  color: #9ca3af;\n  text-align: right;\n}\n\n.admin-error { font-size: 12px; color: #ef4444; }\n\n/* ─── Image upload row ──────────────────────────────────────────────────── */\n.admin-img-row {\n  display: flex;\n  gap: 10px;\n  align-items: stretch;\n}\n\n.admin-upload-btn {\n  white-space: nowrap;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.admin-img-preview-wrap {\n  position: relative;\n  display: inline-block;\n  margin-top: 10px;\n}\n\n.admin-img-preview {\n  width: 160px;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 1.5px solid #e5e7eb;\n  display: block;\n}\n\n.admin-img-preview__remove {\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #ef4444;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  line-height: 1;\n}\n\n/* ─── Form actions ──────────────────────────────────────────────────────── */\n.admin-form__actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n/* ─── Buttons ───────────────────────────────────────────────────────────── */\n.admin-btn {\n  padding: 10px 22px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: opacity .2s, transform .1s;\n}\n.admin-btn:active { transform: scale(.97); }\n\n.admin-btn--primary { background: #4f46e5; color: #fff; }\n.admin-btn--primary:hover { opacity: .88; }\n.admin-btn--ghost {\n  background: transparent;\n  border: 1.5px solid #e5e7eb;\n  color: #374151;\n}\n.admin-btn--ghost:hover { background: #f9fafb; }\n.admin-btn--danger { background: #ef4444; color: #fff; }\n.admin-btn--danger:hover { opacity: .88; }\n\n/* ─── Table card header ─────────────────────────────────────────────────── */\n.admin-table-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.admin-search-wrap {\n  position: relative;\n}\n.admin-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 15px;\n}\n.admin-search-input { padding-left: 36px; width: 220px; }\n\n/* ─── Table ─────────────────────────────────────────────────────────────── */\n.admin-table-wrap { overflow-x: auto; }\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.admin-table th {\n  text-align: left;\n  padding: 10px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: .04em;\n  border-bottom: 1.5px solid #f0f0f0;\n}\n\n.admin-table td {\n  padding: 12px 12px;\n  border-bottom: 1px solid #f5f5f5;\n  vertical-align: middle;\n  color: #374151;\n}\n\n.admin-table tbody tr:last-child td { border-bottom: none; }\n.admin-table tbody tr:hover { background: #fafafa; }\n.admin-table__row--active { background: #f0effe !important; }\n\n.admin-table__title-cell {\n  font-weight: 600;\n  max-width: 220px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-table__date { color: #6b7280; white-space: nowrap; font-size: 13px; }\n\n.admin-table__tags { display: flex; flex-wrap: wrap; gap: 4px; }\n.admin-table__tag {\n  background: #ede9fe;\n  color: #4f46e5;\n  padding: 2px 8px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.admin-table__thumb {\n  width: 52px;\n  height: 36px;\n  object-fit: cover;\n  border-radius: 6px;\n  display: block;\n}\n.admin-table__thumb--empty {\n  width: 52px;\n  height: 36px;\n  border-radius: 6px;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d1d5db;\n  font-size: 16px;\n}\n\n.admin-table__actions { display: flex; gap: 6px; }\n\n.admin-icon-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 7px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  transition: background .15s;\n}\n.admin-icon-btn--edit   { background: #f0effe; color: #4f46e5; }\n.admin-icon-btn--edit:hover   { background: #ddd6fe; }\n.admin-icon-btn--delete { background: #fef2f2; color: #ef4444; }\n.admin-icon-btn--delete:hover { background: #fecaca; }\n\n/* ─── Empty state ───────────────────────────────────────────────────────── */\n.admin-empty {\n  text-align: center;\n  padding: 48px 20px;\n  color: #9ca3af;\n}\n.admin-empty p { margin: 8px 0 0; font-size: 14px; }\n\n/* ─── Responsive ────────────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .admin-page { flex-direction: column; }\n  .admin-page__sidebar {\n    width: 100%;\n    min-height: auto;\n    height: auto;\n    position: static;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n    padding: 16px 20px;\n    gap: 12px;\n  }\n  .admin-sidebar__header { margin-bottom: 0; }\n  .admin-page__main { padding: 20px 16px; }\n  .admin-form__grid { grid-template-columns: 1fr; }\n  .admin-field--full { grid-column: 1; }\n  .admin-search-input { width: 160px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
